import { Injectable, inject } from '@angular/core';
import { SessionStorageService } from '@core/session-storage.service';
import { Subject } from 'rxjs';
import { SecurityReviewEditionCache } from '../abstractions/security-review-edition-cache';
import { SecurityReviewUpdate } from '../abstractions/security-review-update';
import { SecurityTaxResultItemForm } from '../models/edit-tax-result-approval/security-tax-result-item-form';

@Injectable({ providedIn: 'root' })
export class TaxResultSessionService {
  private readonly sessionStorage = inject(SessionStorageService);

  updateSecurity: Subject<SecurityReviewUpdate> = new Subject();
  selectedIds: Subject<void> = new Subject();
  cache: SecurityReviewEditionCache = {
    toAdd: [],
    toDelete: [],
  };

  private activeSecuritiesIdsKey = 'tax-result-items';

  delete(item: SecurityTaxResultItemForm): void {
    if (item.metadata.securityTaxResultItemId) {
      this.cache.toDelete.push(item);
    } else {
      this.cache.toAdd = this.cache.toAdd.filter(
        (cachedItem: SecurityTaxResultItemForm) => {
          return cachedItem.uuid !== item.uuid;
        }
      );
    }
  }

  add(itemForm: SecurityTaxResultItemForm): void {
    const hasItem = this.cache.toAdd.some(
      (item: SecurityTaxResultItemForm) => item.uuid === itemForm.uuid
    );
    if (!hasItem) {
      this.cache.toAdd.push(itemForm);
    }
  }

  update(itemForm: SecurityTaxResultItemForm): void {
    const storedItemField = this.cache.toAdd.find(
      item => item.uuid === itemForm.uuid
    );

    if (storedItemField && storedItemField.rate) {
      storedItemField.rate.value.set(itemForm.rate!.value());
    } else {
      this.add(itemForm);
    }
  }

  cleanCache(): void {
    this.cache.toAdd = [];
    this.cache.toDelete = [];
  }

  selectSecuritiesIdsAndUpdate(values: number[]): void {
    this.selectSecuritiesIds(values);
    this.selectedIds.next();
  }

  selectSecuritiesIds(values: number[]): void {
    this.sessionStorage.set(this.activeSecuritiesIdsKey, values.join(','));
  }

  clearSecuritiesIds(): void {
    this.sessionStorage.remove(this.activeSecuritiesIdsKey);
  }

  getSelectedSecuritiesIds(): number[] {
    const store = this.sessionStorage.get(this.activeSecuritiesIdsKey);

    if (store) {
      return store.split(',').map((id: string) => parseInt(id, 10));
    }
    return [];
  }
}
